import { render } from "./SolveCenter.vue?vue&type=template&id=8e4a0672&scoped=true"
import script from "./SolveCenter.vue?vue&type=script&lang=js"
export * from "./SolveCenter.vue?vue&type=script&lang=js"

import "./SolveCenter.vue?vue&type=style&index=0&id=8e4a0672&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e4a0672"]])

export default __exports__